<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/sebitvcloud.jpg" alt="" />
      <h3 v-if="this.$route.query.token && !errorMsg">Lütfen bekleyiniz, işleminiz devam ediyor.</h3>
      <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import CryptoJS from "crypto-js";

export default {
  name: "SebitVCloud",
  components: {Loading},
  data() {
    return {
      loading: true,
      token: null,
      clientid: null,
      sebitUserData: null,
      errorMsg: '',
      platformMap: [
        {
          clientid: '83a72b470caba4e8',
          platform: 'deutschbesten',
          ueslms_school_id: 109055,
          description: 'IDE Okulları'
        },
        {
          clientid: 'f9dee2b779519e75',
          platform: 'kidzwonder',
          ueslms_school_id: 11558,
          description: 'Doğa Koleji'
        },
        {
          clientid: '37b82cadeb3966a6',
          platform: 'hll',
          ueslms_school_id: 11558,
          description: 'Doğa Koleji'
        },
        {
          clientid: '22690938baeeaf6b',
          platform: 'uesportals',
          ueslms_school_id: 11558,
          description: 'Doğa Koleji'
        },
        {
          clientid: 'ea78295ad5d304f1',
          platform: 'razplus',
          ueslms_school_id: 116004,
          description: 'BCN Koleji'
        },
        {
          clientid: '8486fad91114c1cd',
          platform: 'english-academe-jr',
          ueslms_school_id: 116004,
          description: 'BCN Koleji'
        },
        {
          clientid: 'b5caad38d824360b',
          platform: 'news-o-matic',
          ueslms_school_id: 116004,
          description: 'BCN Koleji'
        },
        {
          clientid: '4860927f3833f388',
          platform: 'sensations-english',
          ueslms_school_id: 116004,
          description: 'BCN Koleji'
        },
        {
          clientid: '4c294f046b15219f',
          platform: 'deutschbesten',
          ueslms_school_id: 116004,
          description: 'BCN Koleji'
        },
        {
          clientid: 'e4bb842c6a1959bc',
          platform: 'kidzwonder',
          ueslms_school_id: 86722,
          description: 'Pendik İkbal Okulları'
        },
        {
          clientid: '7a4f2b1e1d5fb918',
          platform: 'uesportals',
          ueslms_school_id: 86722,
          description: 'Pendik İkbal Okulları'
        },
        {
          clientid: '676352e6208dc323',
          platform: 'efs-plus',
          ueslms_school_id: 86722,
          description: 'Pendik İkbal Okulları'
        },
        {
          clientid: 'c2ad066144952b5c',
          platform: 'richmondlp',
          ueslms_school_id: 86722,
          description: 'Pendik İkbal Okulları'
        },
      ],
    }
  },
  beforeMount() {
    this.loading = true
    const query = this.$route.query;
    if (query.token && query.clientid) {
      this.token = query.token
      this.clientid = query.clientid
      this.sebitValidate()
    }
  },
  methods: {
    async sebitValidate() {
      const ENV = 'beta';
      const baseUrl = 'https://ueslms-service-api.ey.r.appspot.com';
      const url = `${baseUrl}/sebit-validate?token=${this.token}&clientid=${this.clientid}&env=${ENV}`;

      // console.log('validate url', url);

      try {
        const response = await axios.get(url, {
          timeout: 30000, // 30 saniye timeout
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: false // CORS için
        });

        // console.log('validate response.data', response.data);
        // console.log('validate response.status', response.status);

        const data = response.data;
        if (data.appGeneratedId !== null) {
          this.sebitUserData = data;
          this.errorMsg = '';
          this.loading = false;

          const clientid = this.clientid;
          this.goPlatform(clientid);
        } else {
          this.loading = false;
          this.errorMsg = 'Bir hata oluştu: appGeneratedId null.';
        }
      } catch (error) {
        this.loading = false;

        // Detaylı hata loglaması
        // console.error('Axios Error:', error);
        // console.error('Error Message:', error.message);
        // console.error('Error Response:', error.response);
        // console.error('Error Request:', error.request);

        if (error.response) {
          // Sunucu yanıt verdi ama hata kodu döndü (4xx, 5xx)
          // console.error('Response Status:', error.response.status);
          // console.error('Response Data:', error.response.data);
          this.errorMsg = `Sunucu hatası: ${error.response.status} - ${JSON.stringify(error.response.data)}`;
        } else if (error.request) {
          // İstek gönderildi ama yanıt alınamadı (CORS, network hatası)
          // console.error('No response received');
          this.errorMsg = 'Sunucudan yanıt alınamadı. CORS veya ağ hatası olabilir.';
        } else {
          // İstek oluşturulurken hata oluştu
          this.errorMsg = `İstek hatası: ${error.message}`;
        }
      }
    },

    goPlatform(clientid) {
      const platformInfo = this.platformMap.find(item => item.clientid === clientid);
      let secretKey = null;
      let redirectUrl = null;

      if (platformInfo) {
        // console.log('Platform bilgisi:', platformInfo);

        if (platformInfo.platform === 'deutschbesten') {
          secretKey = 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8';
          redirectUrl = 'https://service.ueslms.com/#/deutschbesten/?sso=';
        }
        else if (platformInfo.platform === 'kidzwonder' && this.sebitUserData.role.toLowerCase() === 'student') {
          secretKey = 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8';
          redirectUrl = 'https://service.ueslms.com/#/kidzwonder/?sso=';
        }
        else if (platformInfo.platform === 'kidzwonder' && this.sebitUserData.role.toLowerCase() === 'teacher') {
          secretKey = 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8';
          redirectUrl = 'https://service.ueslms.com/#/uesportals/?sso=';
        }
        else if (platformInfo.platform === 'uesportals') {
          secretKey = 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8';
          redirectUrl = 'https://service.ueslms.com/#/uesportals/?sso=';
        }
        else if (platformInfo.platform === 'hll') {
          secretKey = 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8';
          redirectUrl = 'https://service.ueslms.com/#/hll/?sso=';
        }
        else if (platformInfo.platform === 'efs-plus' || platformInfo.platform === 'english-academe-jr') {
          secretKey = 'Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy';
          redirectUrl = 'https://service.ueslms.com/#/efs/?sso='
        }
        else if (platformInfo.platform === 'razplus' || platformInfo.platform === 'raz-plus') {
          secretKey = 'DZYQSbQQKmruR4ZYOLD%s7163BZjoyViqF7gWy.A6Gd9JAyXCL!eNGsrEJVcPUe';
          redirectUrl = 'https://service.ueslms.com/#/raz-plus/?sso='
        }
        else if (platformInfo.platform === 'sensations-english') {
          secretKey = 'Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy';
          redirectUrl = 'https://service.ueslms.com/#/sensations/?sso='
        }
        else if (platformInfo.platform === 'news-o-matic') {
          secretKey = 'Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy';
          redirectUrl = 'https://service.ueslms.com/#/nom/?sso='
        }
        else if (platformInfo.platform === 'richmondlp' && this.sebitUserData.role.toLowerCase() === 'student') {
          secretKey = 'VswFYGzh2k45N7Q8R9@TBuCVexFY.G2J3K4N6p7Q%9SATB-VdWeXFZHJ3m5N';
          redirectUrl = 'https://service.ueslms.com/#/rlp/?sso='
        }

        // secretKey ve redirectUrl kontrolü
        if (secretKey && redirectUrl) {
          window.location.href = redirectUrl + this.platformHandle(secretKey);
        } else {
          this.loading = false;
          this.errorMsg = `Platform "${platformInfo.platform}" için yapılandırma bulunamadı veya rol uyumsuz.`;
          // console.error('secretKey veya redirectUrl null:', { secretKey, redirectUrl, platform: platformInfo.platform, role: this.sebitUserData?.role });
        }
      } else {
        this.loading = false;
        this.errorMsg = 'Bir hata oluştu: Platform bilgisi bulunamadı.';
      }
    },

    platformHandle(secretKey) {
      const textJson = JSON.stringify(this.uesLmsUserData());
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, secretKey).toString();
      return btoa(ciphertext);
    },

    uesLmsUserData() {
      // console.log('4');
      const platformInfo = this.platformMap.find(item => item.clientid === this.clientid);
      const sebitUserData = this.sebitUserData || {};
      // sebitUserData içerisinde okul/sınıf bilgisi yoksa testler vs için default tanımlama yapıyorum.
      const schoolClassArr = Array.isArray(sebitUserData.school_class) ? sebitUserData.school_class : [
        {
          "schoolcode": "0001",
          "classname": "1-A",
          "level": 1,
          "schoolname": "UES Test Kampüsü",
          "mebschoolcode": "12345"
        }
      ];
      // Okul/sınıf kontrolü
      if (!schoolClassArr.length) {
        this.errorMsg = 'Sebit VCloud datası içerisinde Okul/Sınıf bilgisi bulunamadı.';
        return null;
      }
      // campus_id ve campus_name ilk elemandan alınır
      const campus_name = schoolClassArr[0].schoolname || '';
      const campus_id = schoolClassArr[0].mebschoolcode || 0;
      // class array'i (level 0 olanlar hariç)
      const classArr = schoolClassArr
        .filter(cls => cls.level && cls.level !== 0)
        .map(cls => {
          let branch = cls.classname || '';
          // Branch'ten level ve özel karakterleri temizle
          if (branch && cls.level) {
            // RegExp: level ile başlayan, ardından /, -, boşluk gelebilir, bunları sil, ilk harften itibaren kalan kısmı al
            const re = new RegExp(`^${cls.level}[/ -]*`, 'i');
            branch = branch.replace(re, '');
          }
          return {
            grade: cls.level,
            branch: branch
          }
        });
      return {
        school_id: platformInfo.ueslms_school_id,
        campus_id,
        campus_name,
        first_name: sebitUserData.firstName,
        last_name: sebitUserData.lastName,
        username: sebitUserData.appGeneratedId,
        role_type: sebitUserData.role.toLowerCase(),
        class: classArr,
      }
    }
  }
}
</script>
